import { render, staticRenderFns } from "./ExpenseReason.vue?vue&type=template&id=63f4c920&scoped=true&"
import script from "./ExpenseReason.vue?vue&type=script&lang=js&"
export * from "./ExpenseReason.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseReason.vue?vue&type=style&index=0&id=63f4c920&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f4c920",
  null
  
)

export default component.exports